import { Action } from "redux";

import { TopicStats } from "@/mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.reducers";
import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

export interface CounsellingsHomeFetchAction extends Action {
    readonly query: string;
    readonly after: number; // Last item id
}
export const COUNSELLINGS_HOME_FETCH_REQUEST = "COUNSELLINGS_HOME_FETCH_REQUEST";
export interface CounsellingsHomeFetchRequestAction
    extends CounsellingsHomeFetchAction, APIRequestAction {
    readonly type: typeof COUNSELLINGS_HOME_FETCH_REQUEST;
}
export interface CounsellingsHomeFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        posts: number[];
        topics: number[];
        counsellings: number[];
        followingTopics: number[];
    };
}
export const COUNSELLINGS_HOME_FETCH_SUCCESS = "COUNSELLINGS_HOME_FETCH_SUCCESS";
export interface CounsellingsHomeFetchSuccessAction
    extends CounsellingsHomeFetchAction, APISuccessAction<CounsellingsHomeFetchNormalizedResponse> {
    readonly type: typeof COUNSELLINGS_HOME_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
    readonly notificationsOn: number[];
    readonly topicStats: TopicStats;
    readonly lastVisitCounts: TopicStats;
    readonly totalAnswers: number;
    readonly resultsCount: number;
}

export const COUNSELLINGS_HOME_FETCH_FAILURE = "COUNSELLINGS_HOME_FETCH_FAILURE";
export interface CounsellingsHomeFetchFailureAction
    extends CounsellingsHomeFetchAction, APIFailureAction {
    readonly type: typeof COUNSELLINGS_HOME_FETCH_FAILURE;
}

export const counsellingsHomeFetch = {
    request: (query: string, after: number): CounsellingsHomeFetchRequestAction => ({
        type: COUNSELLINGS_HOME_FETCH_REQUEST,
        query,
        after,
    }),
    success: (
        query: string,
        after: number,
        hasNext: number,
        hasPrevious: number,
        notificationsOn: number[],
        topicStats: TopicStats,
        lastVisitCounts: TopicStats,
        totalAnswers: number,
        resultsCount: number,
        response: CounsellingsHomeFetchNormalizedResponse,
    ): CounsellingsHomeFetchSuccessAction => ({
        type: COUNSELLINGS_HOME_FETCH_SUCCESS,
        query,
        after,
        hasNext,
        hasPrevious,
        notificationsOn,
        topicStats,
        lastVisitCounts,
        totalAnswers,
        resultsCount,
        response,
    }),
    failure: (query: string, after: number, error: any): CounsellingsHomeFetchFailureAction => ({
        type: COUNSELLINGS_HOME_FETCH_FAILURE,
        query,
        after,
        error,
    }),
};

export const COUNSELLINGS_HOME_LOAD = "COUNSELLINGS_HOME_LOAD";
export interface CounsellingsHomeLoadAction extends CounsellingsHomeFetchAction {
    readonly type: typeof COUNSELLINGS_HOME_LOAD;
}
export const counsellingsHomeLoad = (
    query: string,
    after?: number,
): CounsellingsHomeLoadAction => ({
    type: COUNSELLINGS_HOME_LOAD,
    query,
    after,
});
